import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { User } from 'src/app/models/user';
import { Settlement } from 'src/app/models/settlement.model';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { TasksService } from 'src/app/services/tasks.service';
import { CatalogsService } from 'src/app/shared/services/catalogs.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Task } from 'src/app/models/task.model';

@Component({
  selector: '[app-tr-task]',
  template: `
    <td class="align-middle">
      <span *ngIf="authService.hasPermission('can_edit_tasks') && task?.status != 3 && task?.status != 4">
        <a *ngIf="!task?.assignee_id" routerLink="{{task?.id}}">#{{task?.id}} {{task?.builder?.name}}</a>
        <a *ngIf="task?.assignee_id" (click)="selectTask(task)">#{{task?.id}} {{task?.builder?.name}}</a>
      </span>
      <span *ngIf="task?.status == 3 || task?.status == 4">#{{task?.id}} {{task?.builder?.name}}</span>      
    </td>
    <td class="align-middle">
      <div class="clearfix mb-1">
        <div style="width: 32px !important; height: 32px !important; border-radius: 18px; overflow: hidden;" *ngIf="technician?.avatar" class="float-start bg-dark">
          <img [src]="avatar" width="100%" style="border-radius: 18px;">
        </div>
        <div class="float-start ms-2" *ngIf="technician">
          <span *ngIf="technician?.employee_number">#{{technician?.employee_number}}</span>
          <p style="font-size: 15px; line-height: 1;" class="mb-0">{{technician.name}} {{technician.last_name}}</p>
        </div>
      </div>
    </td>
    <td class="align-middle">
      <p class="mb-0" *ngIf="settlement">{{ settlement.name }}</p>
      <p class="mb-0 text-muted" style="font-size: 14px; line-height: 1;" *ngIf="settlement">{{ settlement.address }}, {{settlement.city}}, {{settlement.state}}, {{settlement.zip}}</p>        
      <p class="float-start ms-2" *ngIf="!settlement"><fa-icon [icon]="icons.faCircleNotch" animation="spin" class="text-secondary"></fa-icon></p>
    </td>
    <td class="align-middle">{{ task?.created_at | date: 'dd/MM/yy' }}</td>
    <td class="align-middle text-center">{{ task?.due_date | date: 'dd/MM/yy HH:mm' }}</td>
    <td class="align-middle text-center">{{ task?.completed_at | date: 'dd/MM/yy HH:mm' }}</td>
    <td class="align-middle text-end">
      <button class="btn btn-link" *ngIf="task?.status===3" routerLink="review/{{task?.id}}">
        <fa-icon [icon]="icons.faCalculator"></fa-icon>
      </button>
      <button class="btn btn-link text-danger" *ngIf="task?.status!=3&&task?.status!=4" (click)="deleteTask(task)">
        <fa-icon [icon]="icons.faTrashAlt"></fa-icon>
      </button>
    </td>
  `,
  styles: ``
})
export class TrTaskComponent {
  @Input() task: Task | null = null;
  @Input() builders: any = [];
  @Input() profile: any;
  @Input() technicians: User[] = [];
  @Input() settlements: Settlement[] = [];
  @Output() taskData = new EventEmitter<any>();
  @Output() editTask = new EventEmitter<any>();

  apiUrl: string = environment.AWS_REST_WSPREFIX;
  
  priority: any;
  status: any;
  technician: any;
  settlement: any;
  avatar: any = null;
  loadingExtra: boolean = false;
  builder: any = null;
  
  constructor(
    private toastr: ToastrService,
    private store: SettlementsService,
    private taskService: TasksService,
    private catalog: CatalogsService,
    public icons: IconsService,
    public authService: AuthService
  ) { }
  
  ngOnInit(): void {
    this.priority = this.catalog.priority[this.task?.priority!-1];
    this.status = this.catalog.status[this.task?.status!];
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['builders'] && changes['builders'].currentValue) {
      this.builder = changes['builders'].currentValue.find((e: any) => e.id == this.task?.builder_id);
    }
    if (changes['technicians'] && changes['technicians'].currentValue) {
      if (changes['technicians'].currentValue.length > 0) {
        this.technician = changes['technicians'].currentValue.find((e: any) => e.id == this.task?.assignee_id);
        if(this.technician && this.technician.avatar) {
          this.loadImg(this.technician.avatar);
        }
      }
    }
    if (changes['settlements'] && changes['settlements'].currentValue) {
      if (changes['settlements'].currentValue.length > 0) {
        this.settlement = changes['settlements'].currentValue.find((e: any) => e.id == this.task?.settlement_id);
      }
    }
  }

  selectTask(task: any) {
    this.editTask.emit(task);
  }
  
  loadImg(img: any) {
    // console.log('IMG', img);
    if (img && img.blob) {
      this.avatar = `${this.apiUrl}/storage/${img.blob.key.substring(0,2)}/${img.blob.key.substring(2,4)}/${img.blob.key}`;
    } else {
      this.avatar = '';
    }
  }
  
  deleteTask(task: any) {
    if (confirm(`Confirmar cancelación de la tarea. # ${task.id}`) == true) {
      console.log('Delete Task', task);
      this.taskData.emit(task);
    } else {
      console.log("You canceled!");
    }
  }
}
